import profileReducer from '@app/store/slices/profile-slice'
import usersReducer from '@app/store/slices/users-slice'
import authReducer from '@app/store/slices/auth-slice'
import pwaReducer from '@app/store/slices/pwa-slice'
import deviceReducer from '@app/store/slices/device-slice'
import firmsReducer from '@app/store/slices/firms-slice'
import templatesReducer from '@app/store/slices/templates-slice'
import errorsReducer from '@app/store/slices/error-slice'
import inverterSlice from '@app/store/slices/inverter-slice'
import alarmSlice from '@app/store/slices/alarm-slice'
import partsReducer from '@app/store/slices/parts-slice'
import userConsentsReducer from '@app/store/slices/userConsent-slice'
import rodoPoliciesDocumentsReducer from '@app/store/slices/rodoPoliciesDocuments-slice'
import dataProcessingConsentsReducer from '@app/store/slices/dataProcessingConsents-slice'
import notificationReducer from '@app/store/slices/notification-slice'
import auditLogReducer from '@app/store/slices/audit-log-slice'
import dashboardViewsReducer from '@app/store/slices/dashboard-views-slice'
import inspectionsReducer from '@/store/slices/inspections-slice'
import serviceOrdersReducer from '@/store/slices/service-orders-slice'
import serviceOrderDetailsReducer from '@/store/slices/service-order-details-slice'
import serviceActivitiesReducer from '@/store/slices/service-activities-slice'
import serviceArchiveReducer from '@/store/slices/service-archive-slice'
import serviceRequestsReducer from '@/store/slices/service-requests-slice'
import deviceServiceRequestsReducer from '@/store/slices/device-service-requests-slice'
import myOrdersReducer from '@/store/slices/my-orders-slice'

export default {
  profile: profileReducer,
  users: usersReducer,
  device: deviceReducer,
  auth: authReducer,
  pwa: pwaReducer,
  firms: firmsReducer,
  templates: templatesReducer,
  inspections: inspectionsReducer,
  errorsTemplate: errorsReducer,
  inverter: inverterSlice,
  alarm: alarmSlice,
  parts: partsReducer,
  userConsents: userConsentsReducer,
  rodoPoliciesDocuments: rodoPoliciesDocumentsReducer,
  dataProcessingConsents: dataProcessingConsentsReducer,
  notification: notificationReducer,
  auditLog: auditLogReducer,
  dashboardViews: dashboardViewsReducer,
  serviceOrders: serviceOrdersReducer,
  serviceOrderDetails: serviceOrderDetailsReducer,
  serviceActivities: serviceActivitiesReducer,
  serviceArchive: serviceArchiveReducer,
  serviceRequests: serviceRequestsReducer,
  deviceServiceRequests: deviceServiceRequestsReducer,
  myOrders: myOrdersReducer,
}
